import Avatar from "./avatar";
import { getLargeBadges } from "../badges";
import PayoutStructure from "../containers/payout-structure";
import pure from "./higher-order/pure";
import React from "react";
import { trackListLong } from "../track-list";

export default pure(function TournamentListItemDetails({ races, tickets, tournament, users }) {
  var tracks = trackListLong(races);
  var trackItems = (
    <li>
      <dl className="tournament-table_tracks">
        <dt>
          Track(s):
        </dt>

        <dd>
          TBD
        </dd>
      </dl>
    </li>
  );

  if (Object.keys(tracks).length >= 1) {
    trackItems = Object.keys(tracks).map((track) => (
      <li key={track}>
        <dl className="tournament-table_tracks">
          <dt>
            {track}
            :
          </dt>

          <dd>
            {tracks[track]}
          </dd>
        </dl>
      </li>
    ));
  }

  var tournamentUrl = "/tournaments/" + tournament.get("id");
  var isHead2Head = tournament.get("max_users") === 2;
  var playersLabel = isHead2Head ? "Head 2 Head Players" : "Current Players";

  function avatarSlug(key) {
    return (
      <a className="tooltip tooltip--is-fast" data-tooltip={isHead2Head ? "Waiting for Head 2 Head challenger. Enter now!" : "Waiting for players. Enter now!"} href={tournamentUrl} key={key}>
        <span aria-label="?" className="avatar avatar--is-checkered avatar--is-gray avatar--is-small" />
      </a>
    );
  }

  var avatarLimit = 10;
  var firstTickets = tickets.filter((ticket) => ticket.get("ticket_number") === 1);
  var hiddenAvatars = 0;
  var currentPlayers = firstTickets.count();
  if (currentPlayers > avatarLimit) {
    hiddenAvatars = firstTickets.count() - avatarLimit + 1;
    firstTickets = firstTickets.take(avatarLimit - 1);
  }
  var avatars = firstTickets.map((ticket) => {
    var user = users.get(ticket.get("user_id"));
    var username = "---";
    var userTooltip;
    if (user !== undefined) {
      username = user.get("username");
      var first = user.get("first_name") || "";
      var last = user.get("last_name") || "";
      userTooltip = first + " " + last + " @" + username;
    }
    return (
      <a className="tooltip tooltip--is-fast" data-tooltip={userTooltip} href={tournamentUrl} key={ticket.get("user_id")}>
        <Avatar small={currentPlayers <= 2} tiny={currentPlayers > 2} user={user} />
      </a>
    );
  });
  if (hiddenAvatars > 0) {
    avatars = avatars.push(
      <a className="tooltip tooltip--is-fast" data-tooltip={"+ " + hiddenAvatars + " more players."} href={tournamentUrl} key="hiddenAvatars">
        <span>
          +
          {hiddenAvatars}
        </span>
      </a>
    );
  }
  var avatarSeparator = (
    <span className="tournament-table_player--separator" key="avatarSeparator">
      <span>
        vs
      </span>
    </span>
  );
  if (currentPlayers === 0) {
    avatars = avatars.push(avatarSlug(1));
  }
  if (isHead2Head) {
    avatars = avatars.splice(1, 0, avatarSeparator);
    if (currentPlayers <= 1){
      avatars = avatars.push(avatarSlug(2));
    }
  }

  return (
    <div className="tournament-table_row tournament-table_row--details">
      <div className="tournament-table_meta tournament-table_meta--details">
        <div className="tournament-table_meta_cell tournament-table_meta_cell--prize">
          <PayoutStructure tournament={tournament} />
        </div>

        <div className="tournament-table_meta_cell tournament-table_meta_cell--details">
          <dl className="tournament-table_meta_item">
            <dt>
              Game Details:
            </dt>

            <dd>
              <ul className="tournament-table_tracks-group">
                {trackItems}
              </ul>
            </dd>
          </dl>

          <div className="tournament-table_badges_container">
            {getLargeBadges(tournament, true, true)}
          </div>

          <dl className="tournament-table_meta_item">
            <dt>
              {playersLabel}
              :
            </dt>

            <dd>
              <div className="tournament-table_players">
                {avatars}
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  );
});
